<div class="app-tree">
  <ul>
    <div *ngIf="data.repetidos != null">
      <li class="parent" *ngFor="let repetido of data.repetidos; let i = index"
        (mouseenter)="collapse($event,i)" (mouseleave)="collapse($event,i)">
        {{repetido.valor}}
        <ul *ngIf="mostrarLista[i]">
          <ng-container *ngFor="let item of repetido.lista">
            <li class="search-result-li-two" (click)="seleccionarProducto(item.idproduct)"
              data-bs-toggle="collapse" data-bs-target="#nav-search">
              {{item.item}}
            </li>
          </ng-container>
        </ul>
      </li>
    </div>
    <li class="search-result-li" *ngFor="let item of data.lista" (click)="seleccionarProducto(item.idproduct)"
      data-bs-toggle="collapse" data-bs-target="#nav-search">{{item.partnumber}}</li>
  </ul>
</div>
